module.exports = __webpack_public_path__ + "static/media/edit-78.f8aeb82b.svg";